export const ROUND_HALF_UP = "ROUND_HALF_UP";
export const ROUND_UP = "ROUND_UP";
export const ROUND_DOWN = "ROUND_DOWN";

const DECIMAL_PATTERN = /^([+-])?(?:(\d+)(?:\.(\d*))?|\.(\d+))$/;

function toDecimalPlaces(decimalPlaces) {
    const value = Math.trunc(Number(decimalPlaces));
    if (!Number.isFinite(value)) {
        return 0;
    }
    return Math.max(0, value);
}

function parseParts(value) {
    if (value == null) {
        return null;
    }

    const match = String(value).trim().match(DECIMAL_PATTERN);
    if (!match) {
        return null;
    }

    return {
        sign: match[1] === "-" ? -1 : 1,
        integerPart: match[2] ?? "0",
        fractionalPart: match[3] ?? match[4] ?? "",
    };
}

function shouldRoundUp(fractionalDigits, decimalPlaces, roundingMode) {
    if (!/[1-9]/.test(fractionalDigits)) {
        return false;
    }

    if (roundingMode === ROUND_UP) {
        return true;
    }

    if (roundingMode !== ROUND_HALF_UP || decimalPlaces <= 0) {
        return false;
    }

    return BigInt(fractionalDigits) >= 5n * (10n ** BigInt(decimalPlaces - 1));
}

/**
 * Truncate decimals to the given precision, then round to an integer.
 * Defaults to 2 decimal places.
 */
export function roundToInt(number, roundingMode = ROUND_HALF_UP, decimalPlaces = 2) {
    const parts = parseParts(number);
    if (!parts) {
        return 0;
    }

    const precision = toDecimalPlaces(decimalPlaces);
    const fractionalDigits = precision > 0
        ? parts.fractionalPart.slice(0, precision).padEnd(precision, "0")
        : "";
    const baseInteger = BigInt(parts.integerPart);
    const roundedInteger = shouldRoundUp(fractionalDigits, precision, roundingMode)
        ? baseInteger + 1n
        : baseInteger;

    return Number(parts.sign === -1 ? -roundedInteger : roundedInteger);
}
